var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Page',{attrs:{"total":_vm.data.pageTotal,"current":_vm.data.page,"page-size":_vm.data.pageSize,"show-elevator":"","show-sizer":"","show-total":""},on:{"on-change":_vm.pageChange,"on-page-size-change":_vm.pageSizeChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-190e18a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/page.vue
// module id = null
// module chunks = 